module.exports = __webpack_public_path__ + "img/gallery12.15753fe.jpg";